import * as React from 'react';
import Button from '@mui/material/Button';
import { httpGet, httpPost } from '../../HttpRequestHandling/httpRequestHandler';
import { toast } from 'react-toastify';
import EnhancedDataGrid from '../Common/EnhancedDataGrid'; 
import { GridRowModes, useGridApiRef } from '@mui/x-data-grid';
import AddBoxIcon from '@mui/icons-material/AddBox';
import DeleteIcon from '@mui/icons-material/Delete';
import IconButton from '@mui/material/IconButton';
import { flushSync } from 'react-dom';



export default function AddResources(props) {

	const [state, setState] = React.useState({
		data: [],
		selectedRows: [],
		isDirty: false,
		isRowInProcessMode: false,
		processedRowId: null,
		addOperation: false,
	});
	const [isCommited, setIsCommited] = React.useState(false);
	const apiGridRef = useGridApiRef();
	const [trigger, setTrigger] = React.useState(false);
	const [key, setKey] = React.useState(false);
	React.useEffect(() => {
		fetchTaxMaps();
	}, []);
	React.useEffect(() => {
		if (state.isRowInProcessMode) {
			setState({ ...state, data: state.data.filter((e, i) => (e.apamInvoiceTaxTypeCode || '').trim()), isRowInProcessMode: false })
			setIsCommited(false);
		}
		if (state.isDirty) setTrigger(true);
	}, [isCommited]);

	React.useEffect(() => {
		if (state.isDirty && key && !state.isRowInProcessMode) {
			taxMaps_saveHandler();
			setState((...prev) => {
				let _p = prev[0];
				return { ..._p, isDirty: false }
			});
			setKey(false);
		}
		setTrigger(false);

	}, [trigger, key]);
	React.useEffect(() => {
		if (state.addOperation) {
			apiGridRef.current.startRowEditMode({ id: state.processedRowId, fieldToFocus: 'apamInvoiceTaxTypeCode' });
			setState((prev) => ({ ...prev, addOperation: false }));
		}
	}, [state.addOperation])

	const saveChanges = React.useCallback(() => {
		flushSync(() => {
			if (state.processedRowId) {
				apiGridRef.current.stopRowEditMode({ id: state.processedRowId });
			}
			setKey(true);
		})


	}, [state.processedRowId, state.data]);

	const addResources_cancelHandler = React.useCallback((event) => {
		if (props.onClose) {
			props.onClose(event);
		}
	}, []);


	const taxMaps_saveHandler = React.useCallback((event) => {
		var data = {
			taxTypeCode: props.info.taxTypeCode,
			taxMaps: state.data
		};

		props.info.inProgress(true);

		httpPost("/api/setup/savetaxmaps/", data)
			.then((response) => {
				toast.success('Updated Successfully');
				props.info.inProgress(false);
				addResources_cancelHandler(null);
			}).catch((error) => {
				props.info.inProgress(false);
				toast.error(<div>Taxes Update Failed<br />{error.response.data}</div>);
			});
	}, [state.data])

	const fetchTaxMaps = React.useCallback(() => {

		props.info.inProgress(true);

		httpGet('/api/setup/taxmaps?taxTypeCode=' + encodeURIComponent(props.info.taxTypeCode))
			.then((response) => {
				var data = response.data;
				setState((prev) => ({ ...prev, data: data.map((e, i) => { let d = { ...e, rowId: i }; return d; }) }));

				props.info.inProgress(false);
			})
			.catch((error) => {
				props.info.inProgress(false);
				toast.error('An error occurred while fetching the records');
				console.error('There was an error!', error);
			});
	}, [])

	/////////////////////////////////////////////////////////


	const handleClick = React.useCallback(() => {
		const id = ([...state.data]?.sort((a, b) => b.rowId - a.rowId)[0]?.rowId + 1) || 0;
		setState((prev) => ({
			...prev, isDirty: true,
			isRowInProcessMode: true,
			processedRowId: id,
			addOperation: true,
			data: [{
				rowId: id,
				apamInvoiceTaxTypeCode: "",
				isNew: true,
				taxTypeCode: props.info.taxTypeCode,
				taxTypeCodeNavigation: null
			}, ...prev.data]
		}));
		//apiGridRef.current.startRowEditMode({ id: id, fieldToFocus: 'apamInvoiceTaxTypeCode' });
	}, [state.data]);

	const processRowUpdate = (newrow, oldrow) => { 
		let index = state.data.findIndex((e, i) => e.rowId == newrow.rowId);
		Object.assign(state.data[index], newrow);
		setState((...prev) => { let _p = prev[0]; return { ..._p, isDirty: true, processedRowId: null } })
		setIsCommited(true);
		return newrow;
	}

	const handleRowClick = React.useCallback((params, event) => {
		if (state.isRowInProcessMode) return;
		if (!params.isEditable) {
			return;
		}
		if (!event.currentTarget.contains(event.target)) {
			return;
		}
		if (params.cellMode == GridRowModes.View) //GridRowModes.Edit)
		{
			setState({ ...state, isRowInProcessMode: true, isDirty:true });
			apiGridRef.current.startRowEditMode({ id: params.id });
		}
	}, [state, state.isRowInProcessMode])
	const handleRowSelection = React.useCallback((rows) => {
		let selectedRows = rows.map((e, i) => e.rowId);
		setState((...prev) => {
			let _p = prev[0];
			return { ..._p, selectedRows: selectedRows }
		});
	}, [state])

	const handleRowDelete = React.useCallback(() => {
		setState((...prev) => {
			return { ...prev, isDirty: true, selectedRows: [], data: state.data.filter((e, i) => (state.selectedRows.indexOf(e.rowId) === -1)) }
		});
	}, [state])

	const handleRowEditStop = React.useCallback((e) => {
		if (e.reason === 'escapeKeyDown') {
			if (e.row.apamInvoiceTaxTypeCode) {
				setState((p) => ({
					...p, data: p.data.map(k => {
						if (k.rowId != e.id) return k;
						else {
							return {
								...k, apamInvoiceTaxTypeCode: e.row.apamInvoiceTaxTypeCode
							}
						}
					}),
					isRowInProcessMode: false,
					processedRowId: null
				}));
			} else {
				setState((p) => ({
					...p, data: p.data.filter(k => k.rowId != e.id),
					isRowInProcessMode: false,
					processedRowId: null
				}));
			}

		}
	}, [state])


	//////////////////////////////////////////////////////////
		return (
			<div>
				<h1>Resource List  {props.info.taxTypeCode && <span>({props.info.taxTypeCode})</span>}</h1>
				<div className="form-group">
					<div style={{ display: 'block', overflow: 'auto', width: '100%' }}>
						<EnhancedDataGrid rows={state.data}
							disableColumnMenu
							pagination
							pageSize={10}

							columns={[
								{
									headerName: 'Resource ID',
									field: 'apamInvoiceTaxTypeCode',
									flex: 1
								},
								{
									headerName: 'Resource Name',
									field: 'apamInvoiceTaxTypeCode',
									flex: 1
								}
							]}
							getRowId={(row) => { return row.rowId }}
							apiRef={apiGridRef}
							editMode="row"
							onCellClick={handleRowClick}
							onSelectionChange={handleRowSelection}
							processRowUpdate={processRowUpdate}
							onRowEditStop={handleRowEditStop}
							disableSelectionOnClick
							options={{
								actionsColumnIndex: -1,
								pageSize: 10,
								pageSizeOptions: [10, 20, 30, 40, 50],
								maxBodyHeight: 670
							}}

						/>
					</div>
				</div>
				<Button color="primary" onClick={addResources_cancelHandler} style={{ float: "right" }}>
					Cancel
				</Button>
				<Button autoFocus color="primary" disabled={!state.isDirty} onClick={saveChanges} style={{ float: "right" }}>
					Select
				</Button>
			</div>
		);
}